import React from "react"
import SimpleHeader from "../components/layouts/Header/SimpleHeader"
import TriageHeader from "../components/TriageView/TriageHeader"
import TriagePrintInfoCard from "../components/TriageView/TriagePrintInfoCard"
import TriageViewPrintBelowCard from "../components/TriageView/TriageViewPrintBelowCard"

const TriagePrintView = () => {
  return (
    <>
      <SimpleHeader />
      <TriageHeader />
      <TriagePrintInfoCard />
      <TriageViewPrintBelowCard />
    </>
  )
}

export default TriagePrintView
